import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import AssetImage from '../../BaseComponents/Image/Asset'
import OuterOutline from './OuterOutline'
import GoalOutline from './GoalOutline'
import KickoffLine from './KickoffLine'
import KickoffArea from './KickoffArea'

export type LineupFieldProps = {
    /**
     * width of the lineup field
     */
    width: number
    /**
     * height of the lineup field
     */
    height: number
    /**
     * image which should be displayed centered at the kickoff area
     */
    centerImageUrl?: string
}

export const LINEUP_PADDING = 16
// eslint-disable-next-line @typescript-eslint/no-var-requires
const lineupImageUrl = require('../../assets/lineup/lineup_field.png')

const LineupField: FC<LineupFieldProps> = ({ height, width, centerImageUrl }) => (
    <Grid noExpand position="relative">
        <AssetImage imageUrl={lineupImageUrl} width={width} height={height} />
        <OuterOutline width={width} />
        <GoalOutline top={LINEUP_PADDING} width={width} />
        <GoalOutline bottom={LINEUP_PADDING} width={width} />
        <KickoffLine height={height} width={width} />
        <KickoffArea height={height} width={width} imageUrl={centerImageUrl} />
    </Grid>
)

export default LineupField
